import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/providers/AuthProvider';
import { AuthTerminalLoading } from '@/components/auth/AuthTerminalLoading';

export function LogoutPage() {
 const { logout } = useAuth();
 const navigate = useNavigate();

 useEffect(() => {
  const performLogout = async () => {
   try {
    // Artificial delay to show the cool loading state
    await new Promise((resolve) => setTimeout(resolve, 2000));
    await logout();
    // Redirect to login after a brief success message
    setTimeout(() => {
     navigate('/login');
    }, 1500);
   } catch (error) {
    console.error('Logout failed:', error);
    navigate('/login');
   }
  };

  performLogout();
 }, [logout, navigate]);

 return (
  <AuthTerminalLoading
   title='System Sign Out'
   subtitle='Terminating Secure Session'
   steps={[
    'Closing encrypted data channels...',
    'Purging temporary session cache...',
    'Revoking authentication tokens...',
    'Logging out of central authority...',
    'Securing local workspace...',
   ]}
  />
 );
}
